(() => {
  const money = (cents, currency) => new Intl.NumberFormat('es-ES', {style:'currency', currency}).format(cents / 100);
  function mount(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const hero = root.querySelector('[data-hero]');
    const slides = [...root.querySelectorAll('[data-slide]')];
    slides.forEach((btn, i) => btn.addEventListener('click', () => {
      hero.src = btn.dataset.src;
      hero.alt = btn.dataset.alt;
      root.querySelector('[data-count]').textContent = String(i+1).padStart(2,'0') + ' / ' + String(slides.length).padStart(2,'0');
      root.querySelector('[data-gallery-caption]').textContent = btn.dataset.caption;
      slides.forEach(s => s.setAttribute('aria-pressed', String(s===btn)));
    }));
    const config = root.querySelector('.tp-config');
    const form = config.querySelector('form');
    const button = form.querySelector('[name=add]');
    if (button.disabled) return;
    const bases = form.querySelector('[data-base-options]');
    if(bases) bases.hidden = false;
    const gift = form.querySelector('[data-letter-control]');
    const toggle = gift?.querySelector('[data-gift-toggle]');
    const note = gift?.querySelector('[data-note]');
    const error = form.querySelector('[data-error]');
    if(gift) gift.hidden = false;
    const selectedBase = () => form.querySelector('[name=deco-base]:checked');
    function sync(){
      const active = !!toggle?.checked;
      if(gift){ gift.querySelector('[data-gift-fields]').hidden = !active; note.required=active; note.disabled=!active; }
      const total = Number(config.dataset.plantCents) + Number(selectedBase()?.dataset.cents || 0) + (active ? Number(gift.parentElement.dataset.letterCents) : 0);
      button.querySelector('span').textContent = 'Añadir al carrito · ' + money(total, root.dataset.currency || 'EUR');
    }
    form.addEventListener('change',sync);
    note?.addEventListener('input',()=>{
      note.setCustomValidity('');
      gift.querySelector('[data-counter]').textContent = note.value.length+' / 240';
      gift.querySelector('[data-letter]').textContent = note.value.trim() || 'Tu dedicatoria aparecerá aquí.';
    });
    let pending = false;
    form.addEventListener('submit',async evt=>{
      evt.preventDefault();
      if(pending) return;
      const message=toggle?.checked ? note.value.trim() : '';
      if(toggle?.checked && !message){ note.setCustomValidity('Escribe tu dedicatoria para preparar la carta.'); note.reportValidity(); return; }
      const base=selectedBase()?.value;
      const id=Number(form.elements.id.value);
      const plant={id,quantity:1};
      const items=[plant];
      if(base||message){
        plant.properties={_deco_conjunto:crypto.randomUUID()};
        if(base)items.push({id:Number(base),quantity:1,parent_id:id});
        if(message)items.push({id:Number(gift.parentElement.dataset.letterId),quantity:1,parent_id:id,properties:{Dedicatoria:message}});
      }
      error.hidden=true; pending=true; button.disabled=true;
      try{
        const res=await fetch(config.dataset.add,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        if(!res.ok)throw new Error('cart');
        location.assign(config.dataset.cart);
      }catch{error.hidden=false;pending=false;button.disabled=false;}
    });
    window.addEventListener('pageshow',evt=>{if(evt.persisted){pending=false;button.disabled=false;sync();}});
    sync();
  }
  document.querySelectorAll('[data-deco-editorial]').forEach(mount);
})();